"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function TimedOutIcon(props) {
    var icon = (React.createElement("rect", __assign({ x: "1", y: "1", width: "7", height: "8", fill: "#e4e6e8", stroke: "#84898b", strokeWidth: "2" }, props)));
    if (props.wrap !== undefined && props.wrap === false) {
        return icon;
    }
    else {
        return (React.createElement("svg", { height: "10px", width: "9px" }, icon));
    }
}
exports.TimedOutIcon = TimedOutIcon;
